'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';
import PartnerLinks from 'components/links/partnerLinks';

var HeaderLinks = React.createClass({

    displayName: 'HeaderLinks',

    render() {
        return (
            <div className="header--inner">
                <Link to="login" className="header__logo">
                    <div className="logo__image">
                        <img src="images/logo_retina.png"/>
                    </div>
                    <div className="logo__divider"></div>
                    <div className="logo__title">
                        <h4>{flux.t('header_title')}</h4>
                    </div>
                    <div className="partner-links--header">
                        <PartnerLinks />
                    </div>
                </Link>
            </div>
        );
    }
});

module.exports = HeaderLinks;



// WEBPACK FOOTER //
// ./app/components/header/headerLinks.jsx